import { Text } from '@/components/Text';

interface CardBiographyProps {
  biography: string | null;
}

export const CardBiography = ({ biography }: CardBiographyProps) => {
  if (!biography) return null;

  return (
    <div className="rounded-2xl bg-gray-light/50 p-5 shadow-sm">
      <Text className="text-sm leading-relaxed text-gray-800">{biography}</Text>
    </div>
  );
};
